/*
 * Get-restaurants.ts
 * Description: Includes the declaration
 * of the function for getting a list of restaurants
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';
// Importing Vuex
import {store} from '@/config/plugins';

/**
 * Getting a list of restaurants
 *
 * @return {Object} Promise - a list of restaurants
 */
export function getRestaurants() {
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        const jwt = localStorage.getItem('jwt');
        // Using Axios to send the request
        Axios({
            url: APIURL + 'restaurants',
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            params: {
                page: store.getters.currentPage,
                order_by: store.getters.orderParam,
                sort_by: store.getters.sortParam,
                query: store.getters.queryParam,
            },
            data: {},
        }).then((response) => {
            // Assigning the data array to users
            store.dispatch('setResponse', response.data.data);
            store.dispatch('setLastPage', response.data.meta.last_page);
            resolve();
        }).catch(() => {
            reject();
        });
    });
}
